import merge from "lodash/merge";

//论文投稿
class Contributions {
    constructor() {
        this.id = 0;
        this.title="";//论文题目
        this.authorname = ""; //第一作者姓名
        this.authorphone = "";//第一作者电话
        this.authorcompany = "";//第一作者单位
        this.corauthorname = "";//通讯作者姓名
        this.corauthorphone = "";//通讯作者电话
        this.corauthoremail = "";
        this.file_metadata = null;
        // this.conference = null,
        this.conference_id = 0;
        //this.status="0",
        this.create_time = new Date();
        this.actions=[];//审稿操作
    }
    static getList(filters) {

        const url = process.env.VUE_APP_API_URL + 'api/v1/conftreatisesubmit'
        if (!filters.per_page || filters.per_page == '') {
          filters.per_page = -1  
        }
        filters.order_by_desc = "create_time"
        return axios.get(url, { params: filters }).then((res) => {
          console.log(res)
            let returndata = {}
            returndata.result = []
            let c = new Contributions()
            res.data.results.forEach((x) => {
              let c = new Contributions()
              Object.assign(c, x)
              returndata.result.push(x)
          })
          returndata.total = res.data.total
          return returndata
        })
      } 
      static async getById(paper_id){
        // 通过主键获取唯一记录
        let res = await Contributions.getList({ id: paper_id })
        if(res.total>0){
          return res.result[0]
        }else{
          return null
        }
      }


       createOrUpdate() {
          const url =
            process.env.VUE_APP_API_URL + "api/v1/conftreatisesubmit" 
            if (this.id==0) {
                //新增
              const data = merge({}, this);
              return axios.post(url, data).then((res) => {
                let result = new Contributions();
                result = merge(result, res.data.item);
                console.log(result)
                return result;
              });
            }else{
              //修改
                const data = merge({}, this);

                return axios
                  .put(url, data)
                  .then((res) => {
                    let result = new Contributions();
                    result = merge(result, res.data.item);
                    return result;
                  });
            }
        }
        static delete(id){
            const url = process.env.VUE_APP_API_URL + "api/v1/conftreatisesubmit"
            return axios.delete(url, {params: {id:id}}).then(res=>{
              return true
            })
          }
      

}
export default Contributions;
export {Contributions} ;